import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { getDataTestId } from '@alfalab/core-components-shared/esm';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';
import { l as layoutStyles } from '../../layout.module-302cff58.js';

var styles = {"footer":"side-panel__footer_9rb0s","sticky":"side-panel__sticky_9rb0s","highlighted":"side-panel__highlighted_9rb0s"};
require('./index.css')

var Footer = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, sticky = _a.sticky, _c = _a.layout, layout = _c === void 0 ? 'start' : _c, gap = _a.gap, dataTestId = _a.dataTestId;
    var _d = useContext(ModalContext), footerHighlighted = _d.footerHighlighted, setHasFooter = _d.setHasFooter;
    var responsiveContext = useContext(ResponsiveContext);
    useEffect(function () {
        setHasFooter(true);
    }, [setHasFooter]);
    return (React.createElement("div", { className: cn(styles.footer, className, layoutStyles[layout], gap && layoutStyles["gap-".concat(gap)], (_b = {},
            _b[styles.highlighted] = sticky && footerHighlighted,
            _b[styles.sticky] = sticky,
            _b)), "data-test-id": dataTestId || getDataTestId(responsiveContext === null || responsiveContext === void 0 ? void 0 : responsiveContext.dataTestId, 'footer') }, children));
};

export { Footer };
